/**
 * Bridges Selleasy (lb-upsell) cart refresh to Dost theme.
 *
 * Selleasy drawerRefresh() calls helpers like window.refreshCartDrawer and
 * dispatches cart:update / cart:refresh.
 *
 * - Drawer pages: CartDrawer listens for cart:updated and re-fetches /cart.js
 * - Cart page: main-cart is Liquid-rendered, so a full reload is required
 *   (same approach as byte-free-gift.js and CartPage qty controls)
 */
(function () {
  const THEME_CART_UPDATED = "cart:updated";
  const DEBOUNCE_MS = 150;

  let refreshTimer = null;

  function isCartPage() {
    const cartUrl = window.dostConfig?.routes?.cart_url || "/cart";
    return window.location.pathname === cartUrl || window.location.pathname.startsWith(`${cartUrl}/`);
  }

  function notifyThemeCartUpdated() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(() => {
      if (isCartPage()) {
        window.location.reload();
        return;
      }

      document.dispatchEvent(new CustomEvent(THEME_CART_UPDATED));
    }, DEBOUNCE_MS);
  }

  if (typeof window.refreshCartDrawer !== "function") {
    window.refreshCartDrawer = notifyThemeCartUpdated;
  }

  if (typeof window.refreshCart !== "function") {
    window.refreshCart = notifyThemeCartUpdated;
  }

  const selleasyCartEvents = [
    "cart:update",
    "cart:refresh",
    "theme:cart:refresh",
    "theme:cart:change",
    "product:added",
    "on:cart:change",
  ];

  for (const eventName of selleasyCartEvents) {
    document.addEventListener(eventName, notifyThemeCartUpdated);
  }
})();
